var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizOpeningLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 720,
    viewBox: "0 0 640 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 720,
    fill: "#2E0B67"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.033 408.056L399.119 401.838L409.754 408.464L423.259 415.931L444.485 428.667L425.35 435.632L410.637 427.104L401.4 420.598L382.033 408.056ZM426.676 377.877C430.18 387.501 431.298 396.333 430.032 404.372C428.766 412.411 425.604 419.318 420.547 425.093C415.518 430.858 409.088 435.165 401.258 438.015C393.398 440.876 385.685 441.7 378.117 440.488C370.549 439.276 363.701 436.012 357.574 430.696C351.465 425.341 346.665 417.866 343.172 408.27C339.669 398.645 338.536 389.818 339.774 381.79C341.04 373.75 344.187 366.849 349.216 361.084C354.245 355.32 360.689 351.007 368.548 348.147C376.379 345.296 384.073 344.463 391.63 345.647C399.216 346.82 406.078 350.078 412.216 355.423C418.353 360.767 423.173 368.252 426.676 377.877ZM405.063 385.743C402.991 380.048 400.428 375.531 397.374 372.192C394.349 368.843 390.96 366.707 387.205 365.784C383.48 364.85 379.51 365.15 375.295 366.684C371.109 368.208 367.875 370.53 365.592 373.65C363.31 376.77 362.072 380.591 361.879 385.111C361.715 389.621 362.669 394.724 364.742 400.419C366.815 406.114 369.364 410.636 372.389 413.985C375.442 417.324 378.846 419.455 382.6 420.378C386.354 421.301 390.325 421.001 394.51 419.478C398.725 417.944 401.959 415.622 404.213 412.512C406.496 409.391 407.719 405.576 407.883 401.066C408.076 396.546 407.136 391.438 405.063 385.743ZM487.079 373.354L473.507 336.065L494.351 328.479L518.23 394.086L498.326 401.331L493.88 389.115L493.196 389.364C493.205 393.907 491.889 397.998 489.247 401.636C486.623 405.236 482.847 407.932 477.921 409.725C473.45 411.352 469.148 411.757 465.013 410.941C460.878 410.124 457.202 408.221 453.986 405.231C450.759 402.213 448.23 398.232 446.398 393.288L431.178 351.472L452.065 343.87L465.793 381.585C467.117 385.134 469.077 387.597 471.674 388.974C474.271 390.35 477.165 390.458 480.354 389.297C482.433 388.541 484.132 387.406 485.452 385.894C486.79 384.343 487.622 382.508 487.947 380.391C488.291 378.234 488.002 375.888 487.079 373.354ZM531.525 389.247L507.646 323.64L528.533 316.038L552.412 381.645L531.525 389.247ZM515.328 312.185C512.395 313.253 509.522 313.202 506.71 312.032C503.888 310.835 501.974 308.855 500.969 306.092C499.974 303.359 500.178 300.64 501.58 297.937C502.972 295.205 505.135 293.306 508.068 292.238C511.029 291.16 513.907 291.225 516.7 292.434C519.512 293.603 521.416 295.555 522.411 298.288C523.416 301.05 523.223 303.797 521.831 306.529C520.457 309.222 518.289 311.107 515.328 312.185ZM565.877 376.744L561.54 364.827L578.473 316.726L578.317 316.299L548.973 326.979L543.066 310.748L597.312 291.004L602.069 304.074L586.937 350.214L587.092 350.641L616.308 340.008L622.216 356.239L565.877 376.744Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10_2",
    x: 321.169,
    y: 263.038,
    width: 307.534,
    height: 203.804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 720,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizOpeningLeft);
export default __webpack_public_path__ + "static/media/quiz-opening-left.3000d17e0f16f96cb002e0c2a4a7e9bc.svg";
export { ForwardRef as ReactComponent };